<template>
  <!--begin::Content-->
  <!-- <div class="flex-row-fluid ml-lg-8"> -->
  <!--begin::Card-->

  <div>
    <b-overlay :show="isLoading" variant="white" rounded="sm">
      <!--begin::Header-->
       <b-form class="form" @submit.stop.prevent="onSubmit">
      <!--end::Header-->
      <!--begin::Form-->
            <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
        <div v-if="step2" class="d-flex align-items-stretch flex-column">
              <div class="alert alert-success messaging">
              <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="exclamation circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-exclamation-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path></g></svg>
              Su información ha sido cambiada de forma correcta.
            </div>
        </div>
          <div class="col-lg-12">
              <h5 class="font-weight-bold mt-10 mb-6">Datos</h5>
          </div>

          <div class="form-group">
            <label>Contraseña Actual</label>
           
                <b-form-input
                  class="form-control"
                  id="contrasenaActual"
                  name="contrasenaActual"
                  v-model="$v.form.contrasenaActual.$model"
                  :state="validateState('contrasenaActual')"
                  aria-describedby="contrasenaActual-mensaje-validacion"
                  placeholder="Contraseña Actual"
                  type="password"
                  maxLength="10"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="contrasenaActual-mensaje-validacion"
                >La contraseña actual es obligatoria.</b-form-invalid-feedback>
             
          </div>
          <div class="row">
                    <div class="col-xl-6">
          <div class="form-group">
            <label>Contraseña Nueva</label>
            
                <b-form-input
                  class="form-control"
                  id="nuevaContrasena"
                  name="nuevaContrasena"
                  v-model="$v.form.nuevaContrasena.$model"
                  :state="validateState('nuevaContrasena')"
                  aria-describedby="nuevaContrasena-mensaje-validacion"
                  placeholder="Nueva Contraseña"
                  type="password"
                  maxLength="10"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="nuevaContrasena-mensaje-validacion"
                >La nueva contraseña es obligatoria.</b-form-invalid-feedback>
                           <small class="text-muted">
            La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial
          </small>
          <div v-if="$v.form.nuevaContrasena.$dirty" class="password-requirements text-danger">
            <small v-if="!$v.form.nuevaContrasena.minLength">❌ Falta: Mínimo 8 caracteres</small>
            <small v-if="!$v.form.nuevaContrasena.containsUppercase">❌ Falta: Una letra mayúscula</small>
            <small v-if="!$v.form.nuevaContrasena.containsNumber">❌ Falta: Un número</small>
            <small v-if="!$v.form.nuevaContrasena.containsSpecial">❌ Falta: Un carácter especial</small>
          </div>
          </div>
                    </div> <div class="col-xl-6">
          <div class="form-group">
            <label>Confirmar Contraseña</label>
                <b-form-input
                  class="form-control"
                  id="confirmarContrasena"
                  name="confirmarContrasena"
                  v-model="$v.form.confirmarContrasena.$model"
                  :state="validateState('confirmarContrasena')"
                  aria-describedby="confirmarContrasena-mensaje-validacion"
                  placeholder="Confirmar Contraseña"
                  type="password"
                  maxLength="10"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="confirmarContrasena-mensaje-validacion"
                >La contraseña no coincide</b-form-invalid-feedback>
          </div>
                    </div></div>
          <button
            type="submit"
            ref="btn-Guardar"
             class="btn btn-primary align-self-center"
          >Actualizar</button>
          
        <!--end::Body-->
      </b-form>
      <!--end::Form-->
    </b-overlay>
  </div>
  <!-- </div> -->
  <!--end::Content-->
</template>

<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>
<style >
.float-left{
  float: left;
}
</style>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { UPDATE_INFO_PASSWORD } from "@/core/services/store/auth.module";
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  name: "recuperarContrasena",
  props: ["user", "isLoading"],
  data() {
    return {
      step2:false,
      form: {
        contrasenaActual: "",
        nuevaContrasena: "",
        confirmarContrasena: ""
      }
    };
  },
  validations: {
    form: {
      contrasenaActual: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(10)
      },
      nuevaContrasena: {
       required,
        minLength: minLength(8),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[!@#$%^&*(),.?":{}|<>]/.test(value);
        }
      },
      confirmarContrasena: {
        required,
        sameAsPassword: sameAs("nuevaContrasena")
      }
    }
  },
  
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
     resetForm() {
      this.form = {
        contrasenaActual: null,
        nuevaContrasena: null,
        confirmarContrasena: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const claveActual = this.$v.form.contrasenaActual.$model;
      const confirmacionClave = this.$v.form.confirmarContrasena.$model;
      const nuevaClave = this.$v.form.nuevaContrasena.$model;
      

      const btnGuardar = this.$refs["btn-Guardar"];
      btnGuardar.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(UPDATE_INFO_PASSWORD, {
          claveActual, nuevaClave, confirmacionClave
        })
        .then(resultado => {
          console.log(resultado);
          this.step2=true;
          btnGuardar.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(() => {
          btnGuardar.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>

<style scoped>
.password-requirements small {
  display: block;
  font-size: 0.8em;
  margin-top: 2px;
}
</style>